import { render, staticRenderFns } from "./main.vue?vue&type=template&id=64750c5d&scoped=true&"
import script from "./main.vue?vue&type=script&lang=jsx&"
export * from "./main.vue?vue&type=script&lang=jsx&"
import style0 from "./main.vue?vue&type=style&index=0&id=64750c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_a2ryrgrddytsl2onh2hza74dqa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64750c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\comm\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64750c5d')) {
      api.createRecord('64750c5d', component.options)
    } else {
      api.reload('64750c5d', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=64750c5d&scoped=true&", function () {
      api.rerender('64750c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/dg-tree-select/src/main.vue"
export default component.exports